import useBodyStyleWhileMounted from './useBodyStyleWhileMounted';

/**
 * This hook can be used to assign the body's cursor style. This is useful for cases when you want to assign
 * a cursor to the whole page. For example, you might need a loading cursor, or if you're working on a
 * drag-and-drop ui, you can set the "grabbing" cursor to the whole page.
 *
 * The hook allows components to enabled/disable the cursor on the fly by setting the "enabled" prop, and it cleans
 * up after itself by resetting the cursor to it's original style upon dismounting. There should only be one
 * mounted component at a time that uses this hook because it looks into the DOM's body element's style to know
 * what value to reset the cursor to, and setting multiple cursors can cause problems with them both accessing
 * the body element's style at the same time.
 *
 * Cursors should be css cursors. For a full list see https://developer.mozilla.org/en-US/docs/Web/CSS/cursor
 *
 * @param cursor The cursor to apply to the body's cursor style
 * @param enabled Apply the cursor to the body if true, don't otherwise. See useBodyStyleWhileMounted
 * documentation for more.
 */
export default function useDocumentCursor(cursor: string, enabled: boolean): void {
  useBodyStyleWhileMounted('cursor', cursor, enabled);
}
